import styled from 'styled-components'
import { SkeletonLine } from 'components/Skeleton'
import BulkBar from './BulkBar'
import RemedialsTable from './RemedialsTable'
import TableFilters from './TableFilters'
import { exportRemedialsCsv } from './exportCsv'
import { LIVE_STAGES, hasActiveFilters, viewDef } from './remedialsQuery'
import { INK, MUTED } from './ui'

const TableView = ({
  view, filters, sort, actions, meta, loading, error = false, onRetry, selectedIds, ownerName, buildingId, showBuilding,
  scopeFilters = null, viewPicker = null,
  onFiltersChange, onClearFilters, onSort, onSortChoose, onLoadMore, onSelect, onOpen, onAdd,
  onCreateTask, onComplete, onDismiss, onChangeOwner, onChangeDue, onChangeSeverity, onOpenSource, onOpenComments,
  onBulkConvert, onBulkDismiss, onBulkOwner, onBulkDue,
}) => {
  const def = viewDef(view)
  const total = meta?.total ?? 0
  const filtered = hasActiveFilters(filters)
  const emptyText = filtered ? 'No remedials match these filters. Try clearing them.' : def.empty
  const isLiveView = def.stages.some(stage => LIVE_STAGES.includes(stage))

  return (
    <Wrap>
      <TableFilters
        view={view}
        filters={filters}
        sort={sort}
        ownerName={ownerName}
        buildingId={buildingId}
        scopeFilters={scopeFilters}
        viewPicker={viewPicker}
        exportCount={actions.length}
        onExport={() => exportRemedialsCsv(actions)}
        onChange={onFiltersChange}
        onClear={onClearFilters}
        onSortChoose={onSortChoose}
      />
      <Tools>
        {error && actions.length === 0
          ? null
          : loading && actions.length === 0
          ? <SkeletonLine $w='180px' $h={14} />
          : <Total aria-live='polite'>Showing {actions.length} of {total} remedial{total === 1 ? '' : 's'}</Total>}
        {actions.length > 0 && <Hint>Click a row to see its details. Use the ⋮ button for quick actions.</Hint>}
      </Tools>
      <RemedialsTable
        actions={actions}
        meta={meta}
        loading={loading}
        error={error}
        onRetry={onRetry}
        sort={sort}
        selectedIds={selectedIds}
        emptyText={emptyText}
        showBuilding={showBuilding}
        onSort={onSort}
        onSelect={onSelect}
        onLoadMore={onLoadMore}
        onOpen={onOpen}
        onCreateTask={onCreateTask}
        onComplete={onComplete}
        onDismiss={onDismiss}
        onChangeOwner={onChangeOwner}
        onChangeDue={onChangeDue}
        onChangeSeverity={onChangeSeverity}
        onOpenSource={onOpenSource}
        onOpenComments={onOpenComments}
        onAdd={!filtered && isLiveView ? onAdd : undefined}
        onClearFilters={filtered ? onClearFilters : undefined}
      />
      <BulkBar
        ids={selectedIds}
        actions={actions}
        onClear={() => onSelect([])}
        onConvert={onBulkConvert}
        onDismiss={onBulkDismiss}
        onOwner={onBulkOwner}
        onDue={onBulkDue}
      />
    </Wrap>
  )
}

export default TableView

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
`

const Tools = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 12px;
  padding: 0 4px;
`

const Total = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${INK};
`

const Hint = styled.span`
  font-size: 14px;
  color: ${MUTED};
  @media (max-width: 768px) { display: none; }
`
